"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Service
 * Provides OIDC and Security endpoints as well as CRUD operations for SAVE and E-Verify Users and Points of Contact.
 *
 * The version of the OpenAPI document: 2.7.28
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemErrorCodeToJSON = exports.SystemErrorCodeFromJSONTyped = exports.SystemErrorCodeFromJSON = exports.SystemErrorCode = void 0;
/**
 * System error codes that may be returned by user service due to an unexpected system error to aid with troubleshooting:   * `GENERAL_SYSTEM_ERROR` - Indicates that an unexpected issue was encountered.   * `PASSWORD_SYSTEM_ERROR` - There was an unexpected issue when attempting to set a user\'s password.   * `INTERNAL_DATA_ERROR` - An unknown database/SQL error occurred.   * `EMAIL_SEND_FAILED` - The attempt to send an email message failed.   * `MESSAGING_SEND_FAILED` - A failure occured while sending a notification to dependent services.
 * @export
 * @enum {string}
 */
var SystemErrorCode;
(function (SystemErrorCode) {
    SystemErrorCode["GENERALSYSTEMERROR"] = "GENERAL_SYSTEM_ERROR";
    SystemErrorCode["PASSWORDSYSTEMERROR"] = "PASSWORD_SYSTEM_ERROR";
    SystemErrorCode["INTERNALDATAERROR"] = "INTERNAL_DATA_ERROR";
    SystemErrorCode["EMAILSENDFAILED"] = "EMAIL_SEND_FAILED";
    SystemErrorCode["MESSAGINGSENDFAILED"] = "MESSAGING_SEND_FAILED";
})(SystemErrorCode = exports.SystemErrorCode || (exports.SystemErrorCode = {}));
function SystemErrorCodeFromJSON(json) {
    return SystemErrorCodeFromJSONTyped(json, false);
}
exports.SystemErrorCodeFromJSON = SystemErrorCodeFromJSON;
function SystemErrorCodeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SystemErrorCodeFromJSONTyped = SystemErrorCodeFromJSONTyped;
function SystemErrorCodeToJSON(value) {
    return value;
}
exports.SystemErrorCodeToJSON = SystemErrorCodeToJSON;
